/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_profile_chart_fantasy_score_dist = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fantasy Score Distribution`)
};

const es_f1_profile_chart_fantasy_score_dist = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distribución de Puntuación Fantasy`)
};

const de_f1_profile_chart_fantasy_score_dist = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fantasy-Punkteverteilung`)
};

const nl_f1_profile_chart_fantasy_score_dist = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fantasy-scoreverdeling`)
};

const fr_f1_profile_chart_fantasy_score_dist = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distribution des scores fantasy`)
};

const it_f1_profile_chart_fantasy_score_dist = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distribuzione punteggio fantasy`)
};

const pt_br2_f1_profile_chart_fantasy_score_dist = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distribuição de pontuação Fantasy`)
};

const pt_f1_profile_chart_fantasy_score_dist = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distribuição de pontuação fantasy`)
};

const ja_f1_profile_chart_fantasy_score_dist = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファンタジースコア分布`)
};

const zh_f1_profile_chart_fantasy_score_dist = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`梦幻得分分布`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_profile_chart_fantasy_score_dist = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_profile_chart_fantasy_score_dist(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_profile_chart_fantasy_score_dist", locale)
	if (locale === "en") return en_f1_profile_chart_fantasy_score_dist(inputs)
	if (locale === "es") return es_f1_profile_chart_fantasy_score_dist(inputs)
	if (locale === "de") return de_f1_profile_chart_fantasy_score_dist(inputs)
	if (locale === "nl") return nl_f1_profile_chart_fantasy_score_dist(inputs)
	if (locale === "fr") return fr_f1_profile_chart_fantasy_score_dist(inputs)
	if (locale === "it") return it_f1_profile_chart_fantasy_score_dist(inputs)
	if (locale === "pt-BR") return pt_br2_f1_profile_chart_fantasy_score_dist(inputs)
	if (locale === "pt") return pt_f1_profile_chart_fantasy_score_dist(inputs)
	if (locale === "ja") return ja_f1_profile_chart_fantasy_score_dist(inputs)
	return zh_f1_profile_chart_fantasy_score_dist(inputs)
};